import { observer } from "mobx-react";
import ListLayout from "../../../../components/layouts/list-layout/list-layout";
import customizationStore from "../../../../stores/customizations/customization-store";
import { useCallback, useEffect, useState } from "react";
import usePage from "../../../../components/layouts/base-page-layout/page-hook";
import useNavigationBlocker from "../../../../hooks/navigation-blocker-hook";
import EditorPageLayout from "../../../../components/layouts/editor-page/editor-page-layout";
import { ConfirmModal } from "../../../../components/modal/components/confirm-modal/confirm-modal";
import GeneralCard from './general-card/general-card';
import BackgroundCard from './background-card/background-card';

const TrackingPortalSettingsEditorPage: React.FC = observer(() => {
    const [isShowUnsaved, setIsShowUnsaved] = useState(false);

    const { setSubTitles } = usePage();

    useEffect(() => {
        setSubTitles(['Portal', 'Look and Feel', 'Tracking portal settings']);
    }, [setSubTitles]);

    const hasChanges = () => {
        return customizationStore.hasChanges();
    }

    const { retryNavigation, unblockNavigation } = useNavigationBlocker(
        () => hasChanges(),
        useCallback(() => setIsShowUnsaved(true), [setIsShowUnsaved])
    );

    const discardChanges = () => {
        customizationStore.discardChanges();
    }

    const onSaveClicked = () => {
        const promised = [];

        if (hasChanges()) {
            promised.push(
                customizationStore.save()
            );
        }

        Promise.all(promised).then((results) => {
            if (results.every((r) => r !== false)) {
                unblockNavigation();
            }
        }).catch(() => {
            // save errors are already surfaced via the global error modal (http-service)
        })
    }

    return (
        <>
            <EditorPageLayout toolbar={{
                hasLocalesSelector: false,
                saveButton: {
                    hasChanges: hasChanges(),
                    disabled: !hasChanges(),
                    onClick: onSaveClicked
                },
            }}>
                <ListLayout>
                    <GeneralCard/>
                    <BackgroundCard/>
                </ListLayout>
            </EditorPageLayout>

            {isShowUnsaved &&
                <ConfirmModal
                    cancelButton={{
                        title: 'Cancel',
                        onClick: () => setIsShowUnsaved(false)
                    }}
                    okButton={{
                        title: 'Discard',
                        onClick: () => {
                            discardChanges();
                            setIsShowUnsaved(false);
                            retryNavigation();
                        }
                    }}
                />
            }
        </>
    );
});

export default TrackingPortalSettingsEditorPage;
